'use client'

import { LocaleDataProvider } from '@b-stock/fe-core/bstock-react'

import { localeData } from '@/locale/localeData'

/**
 * Supplies the i18n catalog to fe-core's `BStockIntlProvider` through context
 * instead of as a Server Component → Client Component prop.
 *
 * `localeData` is build-time static and (currently) English-only. Passing it as
 * a prop from the server `providers.tsx` serialized the entire ~580 KB catalog
 * into the RSC Flight payload on *every* response, including routes that render
 * a handful of strings. Importing it here — inside a `'use client'` module —
 * bundles it into a fingerprinted client chunk that the browser caches
 * immutably: downloaded once per build and reused across every navigation and
 * visit, out of the per-request HTML entirely. SSR text stays correct because
 * this module also runs on the server during render.
 */
export default function LocaleData({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <LocaleDataProvider localeData={localeData}>{children}</LocaleDataProvider>
  )
}
